// extracted by mini-css-extract-plugin
module.exports = {"LogoSection":"LogoSection_LogoSection__6YFYZ","paragraph":"LogoSection_paragraph__dgHk3"};